import { Component, Prop } from 'vue-property-decorator'

import EditKgis from '@src/routes/members/components/health-goals/edit-kgis'
import { CreateElement } from 'vue'
import { Body2, Subtitle1 } from '@src/elements/typography/typography'
import { Spacer } from '@src/elements/spacer/spacer'
import { Button } from '@src/elements/button/button'
import { KGITooltip } from '@src/routes/members/components/health-goals/kgi-tooltip'

@Component({
  computed: {
    activities () {
      return this.$store.state.activities || []
    },
    exerciseTags () {
      return this.$store.state.completeExerciseTags || []
    },
    goal () {
      return this.$store.state.goal
    }
  }
})
export default class WizardEditKgis extends EditKgis {

  @Prop({ required: false, default: false })
  private saveOnChange: boolean

  constructor () {
    super()
  }

  beforeDestroy () {
    if (this.saveOnChange) {
      // return this.save()
    }
  }

  render (h: CreateElement) {
    const kgis = this.buildKgisRows(h)

    return <div class='edit-kgis'>
      <Subtitle1>{this.$t('PAGE.MEMBERS.GOALS.KEY_HEALTH_GOAL_INDICATOR')}</Subtitle1>
      <Body2>{this.$t('PAGE.MEMBERS.GOALS.KGI_DESCRIPTION_1')}</Body2>
      <Spacer />

      <Button type='remove' ref='addKgiBtn' class='add-kgi-btn' label={this.$t('PAGE.MEMBERS.GOALS.ADD_KGI')} click={this.showHideAddKGI} icon={'util/add'} />
      {this.showAddKGI ? <KGITooltip closeCallback={this.showHideAddKGI} /> : null}

      <div class='kgis-wrapper'>{kgis}</div>
    </div>
  }
}
